/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedBlurbLeadTime_item$ref = any;
type PdpSharedBlurbReturns_item$ref = any;
type PdpSharedBlurbShipping_item$ref = any;
type PdpSharedBlurbSupportNumber_item$ref = any;
type PdpSharedBlurbUrgency_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarBlurbs_item$ref: FragmentReference;
export type PdpRespSidebarBlurbs_item = {|
  +$fragmentRefs: PdpSharedBlurbLeadTime_item$ref & PdpSharedBlurbReturns_item$ref & PdpSharedBlurbShipping_item$ref & PdpSharedBlurbUrgency_item$ref & PdpSharedBlurbSupportNumber_item$ref,
  +$refType: PdpRespSidebarBlurbs_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbReturns_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbUrgency_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '51f61c43a822965eeeae3db5114573e3';
module.exports = node;
